;(function(w){
	function LightboxCreditos(){
		var self = this;
		this.main = document.getElementById('lightbox_creditos');

		var volver_btn = $(this.main).find('.return')[0];

		$(this.main).find('.scroll-holder').mCustomScrollbar();

		$(volver_btn).bind('click', onClickVolverBtn);

		this.mostrar = function(){
			$(self.main).addClass('active');
		}

		this.ocultar = function(){
			$(self.main).removeClass('active');
		}

		function onClickVolverBtn(e){
			e.preventDefault();

			self.ocultar();
		}
	}
	
	w.LightboxCreditos = LightboxCreditos;
})(window)